export const redirectToOldSite = () => {
  window.location.href = 'https://konekt.efkt.com/';
};
